export default async function* uniqAsyncIterable<T>(
    iterable: AsyncIterable<T>,
    getUniqValue: (t: T) => string | number
) {
    const seen: Record<string | number, boolean> = {};
    for await (const value of iterable) {
        const uniqValue = getUniqValue(value);
        if (!seen[uniqValue]) {
            yield value;
            seen[uniqValue] = true;
        }
    }
}

// uniqSavedItems is a variation of uniqAsyncIterable that prioritizes
// local saved items if duplicate remote and local IDs exist in the iterable.
// Order is preserved according to the order in which IDs were first seen.
export async function* uniqSavedItems(iterable: AsyncIterable<SavedItem>) {
    // Storing the values and index the item was last seen allows
    // us to preserve the original sort order and overwrite the
    // remote item's position in the collection
    const seenIndex: Record<string, number> = {};
    const dedupedSavedItems = [];

    let index = 0;
    for await (const item of iterable) {
        const {id, localId} = item;
        const lastSeenIndex = seenIndex[id!];
        if (!id || lastSeenIndex === undefined) {
            dedupedSavedItems.push(item);
            // Fall back to localId to cover the case where an item has been
            // saved locally but the request to the server has not yet completed
            seenIndex[(id || localId)!] = index;
            index++;
        } else if (localId) {
            // Overwrite the previous entry with the local item
            dedupedSavedItems[lastSeenIndex] = item;
            seenIndex[id] = lastSeenIndex;
        }
    }

    for (const item of dedupedSavedItems) {
        yield item;
    }
}
